<template>
  <div
    ref="frisbuy-widget-gallery"
    :class="{
      'frisbuy-widget': true,
      'frisbuy-class': true,
      'frisbuy-vertical': isVerticalGallery,
      [`frisbuy-layout-${gallerySettings.layout}`]: gallerySettings.layout,
      [`frisbuy-${settings.customerCode}`]: true,
    }"
    :style="[galleryStyle]"
  >
    <!-- <script
      src="https://connect.facebook.net/en_US/all.js"
      async=""
      type="application/javascript"
      v-if="settings.popup.shareButtons.fb"
    ></script> -->
    <div class="frisbuy-header">
      <div
        class="frisbuy-title"
        v-if="headerSettings.title || headerSettings.buttonTitle"
      >
        {{ headerSettings.title
        }}<a
          v-if="headerSettings.buttonTitle"
          :href="headerSettings.buttonLink"
          >{{ headerSettings.buttonTitle }}</a
        >
      </div>
      <div
        v-if="headerSettings.subTitle"
        class="frisbuy-subtitle"
        :style="[subTitleStyle]"
      >
        {{ headerSettings.subTitle }}
      </div>
      <div v-if="headerSettings.html" v-html="headerSettings.html"></div>
    </div>
    <div class="frisbuy-categories" v-if="gallerySettings.filters.params">
      <a
        :href="`#tag=${filter.value ? filter.name : 'Все'}`"
        :class="{
          'frisbuy-category': true,
          'frisbuy-active':
            filterValue == filter.value ||
            (filterValue == null && !filter.value),
        }"
        v-for="filter in gallerySettings.filters.params"
        @click="chosenFilter(filter)"
        >{{ filter.name }}</a
      >
    </div>
    <div class="frisbuy-gallery">
      <div
        :class="{
          'frisbuy-scroll-wrapper': true,
          'no-scroll-width': !isVerticalGallery && scrollWidth < 0,
        }"
        :style="{
          height:
            isVerticalGallery &&
            gallerySettings.maxCols &&
            `${
              (containerItemHeight + containerItemMargin) *
              gallerySettings.maxCols
            }px`,
        }"
        v-touch:swipe="swipeHandler"
        ref="postsScroll"
      >
        <div
          :style="{
            padding:
              isLineRowsMode &&
              scrollWidth < 0 &&
              `0 ${containerItemMargin / 2}px`,
          }"
        >
          <ul
            :class="{
              'frisbuy-gallery-posts': true,
              'frisbuy-gallery-multiline': isLineRowsMode,
              [`frisbuy-scheme-${gallerySettings.scheme}`]:
                gallerySettings.layout == 'tile' && gallerySettings.scheme,
            }"
            :style="{
              margin: `-${containerItemMargin / 2}px`,
              width: `calc(100% + ${containerItemMargin}px)`,
              maxHeight:
                !isVerticalGallery && isLineRowsMode && containerRowsHeight,
            }"
          >
            <template v-for="(post, index) in postList">
              <li
                v-if="
                  gallerySettings.scheme &&
                  !isTablet &&
                  (index == 5 || !((index - 5) % 9))
                "
                class="frisbuy-divider"
              ></li>
              <li
                v-if="index === 0 && gallerySettings.layout == 'arrow'"
                :style="{
                  width: getPostItemWidth(index),
                  margin: `${containerItemMargin / 2}px`,
                  'flex-shrink': 0,
                }"
              >
                <ImageUploadPost />
              </li>
              <ad-post
                v-if="post.frisbuyPost.type === 'advertising'"
                :currentIndex="index"
                :style="{
                  width: getPostItemWidth(index),
                  margin: `${containerItemMargin / 2}px`,
                }"
                @open-post="openPost"
                :settings="settings"
              ></ad-post>
              <post-item
                v-else
                :post="post"
                :key="post.frisbuyPost.id"
                :index="index < 1 ? index : index + 1"
                ref="postImage"
                :settings="settings"
                :mobile-settings="mobileSettings"
                :style="{
                  width: getPostItemWidth(index),
                  margin: `${containerItemMargin / 2}px`,
                }"
                :observer="imageObserver"
                @click.native="clickPostHandler(post, index)"
              >
              </post-item>
            </template>
          </ul>
        </div>
      </div>
      <div
        v-if="
          gallerySettings.layout == 'arrow' &&
          ((isVerticalGallery && scrollTop > 0) || scrollWidth > 0)
        "
        :class="{
          'frisbuy-gallery-navigation': true,
          'frisbuy-big': isLineRowsMode,
        }"
      >
        <div
          :class="{
            'frisbuy-navigation-button': true,
            'frisbuy-navigation-button-disabled': !canPrevScroll,
          }"
          @click="slideHandler(-1)"
        >
          <svg
            width="16.530331"
            height="13.06066"
            viewBox="0 0 16.530331 13.06066"
            version="1.1"
            id="svg4"
          >
            <path
              d="M 6.5303301,0.53033009 0.53033009,6.5303301 m 0,0 L 6.5303301,12.53033 M 0.53033009,6.5303301 H 8.5303301 16.53033"
              id="path2"
            />
          </svg>
        </div>
        <span></span>
        <div
          :class="{
            'frisbuy-navigation-button': true,
            'frisbuy-navigation-button-disabled': !canNextScroll,
          }"
          @click="slideHandler(1)"
        >
          <svg
            width="16.530331"
            height="13.06066"
            viewBox="0 0 16.530331 13.06066"
            version="1.1"
            id="svg4"
          >
            <path
              d="M 6.5303301,0.53033009 0.53033009,6.5303301 m 0,0 L 6.5303301,12.53033 M 0.53033009,6.5303301 H 8.5303301 16.53033"
              id="path2"
            />
          </svg>
        </div>
      </div>
    </div>
    <div
      v-if="gallerySettings.branding"
      :class="[{ 'frisbuy-branding': true }, gallerySettings.branding]"
    >
      Сделано на
      <a
        :href="
          settings.brandingLink ||
          'https://www.frisbuy.ru/?utm_source=gallery&utm_medium=referral&utm_campaign=' +
            settings.customerCode
        "
        rel="nofollow"
        target="_blank"
      >
        <img
          :src="`${envDomain}/images/widget/frisbuy_logo_gray.svg`"
          alt="Frisbuy"
        />
      </a>
    </div>
    <div class="frisbuy-footer">
      <div
        :style="{ marginTop: gallerySettings.loadMore.marginTop + 'px' }"
        class="frisbuy-loadmore-button"
        v-if="
          gallerySettings.layout == 'tile' &&
          gallerySettings.loadMore.enable &&
          gallerySettings.loadMore.show
        "
        @click="loadMoreHandler"
      >
        {{ gallerySettings.loadMore.text || "Ещё" }}
      </div>
      <div
        v-if="gallerySettings.footer.html"
        v-html="gallerySettings.footer.html"
      ></div>
    </div>
    <div
      v-if="gallerySettings.guideline.html && isGuidlineOpen"
      class="frisbuy-guideline"
    >
      <div class="frisbuy-guideline-container">
        <div v-html="gallerySettings.guideline.html"></div>
      </div>
    </div>
  </div>

  <Popup
    v-if="isShowPopup"
    :settings="settings"
    :mobileSettings="mobileSettings"
    :postList="postList"
    :post="currentPost"
    :postIndex="currentPostIndex"
    @changePost="
      (direction) =>
        selectPost(
          postList[currentPostIndex + direction],
          currentPostIndex + direction
        )
    "
    @close="() => closePopup()"
  />
</template>

<style scoped src="../../../gallery/gallery/gallery.scss" lang="scss"></style>

<style scoped lang="scss">
$lassiePrimaryColor: #002354;
$arrowButtonsWidth: 46px;

.frisbuy-gallery-navigation {
  width: calc(100% + 48px); // 48px - width .frisbuy-navigation-button
  left: calc(-48px / 2);

  .frisbuy-navigation-button {
    width: 48px;
    height: 48px;

    transform: none;
    opacity: 1;
    box-shadow: 0px 0px 40px 0px #00235417;

    margin: 0;

    &.frisbuy-navigation-button-disabled {
      opacity: 0;
    }

    &:last-child {
      transform: scale(-1, 1);
    }

    svg {
      width: 22px;
      height: 16px;

      &,
      path {
        fill: $lassiePrimaryColor;
        stroke: $lassiePrimaryColor;
        stroke-width: 1.5;
      }
    }

    &:hover {
      svg {
        &,
        path {
          fill: #667b98;
          stroke: #667b98;
        }
      }
    }
  }
}
</style>

<script>
import defaultGallery from "@/gallery/gallery/gallery.vue";
import AdPost from "../components/ad-post.vue";
import Popup from "../../lassie_infinity_images/popup/popup.vue";
import PostItem from "../../lassie_infinity_images/postitem/postitem.vue";
import ImageUploadPost from "../components/ImageUploadPost.vue";

export default {
  extends: defaultGallery,

  components: {
    AdPost,
    Popup,
    "post-item": PostItem,
    ImageUploadPost,
  },

  methods: {
    openPost(index) {
      const { postList, clickPostHandler } = this;

      clickPostHandler(postList[index], index);
    },
  },
};
</script>
